import type { FaireProductEntity } from "../../entity_types/product";

export const p_5z2rf8aan8: FaireProductEntity = {
  token: "p_5z2rf8aan8",
  type: "product",
  name: "Flower Bouquet Goat Milk & Tallow Soap",
  brandName: "Sweet Prairie Farm, LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/a8e93427ee52c3e64d1680ae0ab7d1dec1087734f87169b13b3dfdd92a7201b3.jpeg",
  priceDollars: 5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/02df69025da48e9c0388eea7bc8de6f2be7bf9324e1588ab3aaf7ac5c64e7ab7.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
